<template>
  <div class="cr-addresses">
    <div class="cr-container">
      <div class="cr-addresses__new">
        <Form :validation-schema="schema"
               v-slot="{ errors, meta, handleSubmit }"  :validateOnMount="false">
          <form class="cr-addresses__form cr-form" @submit.prevent="handleSubmit(send)">
          <div v-if="success" class="cr-form__messages">
            <div class="cr-message cr-message--done">
              Запрос отправлен.
            </div>
          </div>
          <div v-if="!success && Object.values(errors).length > 0 " class="cr-detail-card__message cr-message cr-message--error">
            <div>
              <div v-for="error in errors" v-html="error"></div>
            </div>
          </div>
          <fieldset class="cr-form__fieldset">
             <div class="cr-form__field">
              <label class="cr-form__label" for="Comment">
                Комментарий
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </label>
              <Field as="textarea" name="comment"
                     class="cr-form__textarea" v-model="formData.comment" id="Comment" rows="1"/>
            </div>
          </fieldset>
          <div class="cr-form__bottom">
            <button class="cr-button" type="submit">
                                <span class="cr-button__text">
                                    Отправить запрос
                                </span>
            </button>
          </div>
            </form>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>

import scrollToError from "@/mixin/scrollToError.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import axios from "axios";
import { Form, Field} from 'vee-validate';
import * as yup from 'yup';
import {debounce} from "lodash";


export default {
  data: () => ({
    isSubmitting: null,
    serverError: null,
    success: false,
    formData: {
      comment: ''
    },
  }),
  mixins: [scrollToError],
  components: {Form, Field},
  setup() {
    const schema = yup.object().shape({
      comment: yup.string()
          .required('Комментарий обязателен для заполнения')
    });

    return {
      schema
    }
  },
  async created() {

  },

  methods: {
    async send(values
    ) {
        this.isSubmitting = true;
        this.serverError = null;
      this.success = false;

      const formDataToSubmit = {
        ...this.formData,
      };

      let url = '/api/user/remove/';
      try {
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }


       this.success = true;
        this.formData = {
          comment: ''
        }


      } catch (error) {
        this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
  }
}
</script>
